<template>
  <div class="agency-event-ranking-list">
    <div v-if="shouldShowRanking">
      <div class="ranking-header">
        <div class="ranking-header__title">
          {{ displayTitle }}
          
          <span class="ranking-header__participants-counter-container">
            <span class="ranking-header__participants-counter">
              <img class="ranking-header__participants-counter-icon" src="/img/icon-person.svg" />
              <span class="ranking-header__participants-counter-text">{{ rankingList.length }}</span>
            </span>
          </span>
        </div>
      </div>
      
      <div class="ranking-content">
        <template v-if="rankingType === 'individual'">
          <agency-event-ranking-entry
            v-for="(rankingItem, index) in rankingList"
            :key="rankingItem.vliveId"
            :rankingItem="rankingItem"
            :index="index"
          />
        </template>
        
        <template v-if="rankingType === 'group'">
          <agency-event-ranking-group-entry
            v-for="(rankingItem, index) in rankingList"
            :key="rankingItem.groupId"
            :rankingItem="rankingItem"
            :index="index"
            @openGroupIndividualRanking="handleOpenGroupIndividualRanking"
          />
        </template>
      </div>
    </div>
    
    <div v-else class="empty-state">
      <div class="empty-state__container">
        <img class="empty-state__img" src="/img/noDisplayIcon.png" />
        <div class="empty-state__description">
          <p>{{ $t('agencyEventRankingEmptyMessage') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AgencyEventRankingEntry from './AgencyEventRankingEntry.vue'
import AgencyEventRankingGroupEntry from './AgencyEventRankingGroupEntry.vue'

export default {
  components: {
    AgencyEventRankingEntry,
    AgencyEventRankingGroupEntry,
  },
  name: 'AgencyEventRankingList',
  props: {
    rankingList: {
      type: Array,
      default: () => [],
    },
    eventId: {
      type: Number,
      required: true,
    },
    rankingType: {
      type: String,
      default: 'individual',
      validator: (value) => ['individual', 'group'].includes(value),
    },
    groupName: {
      type: String,
      default: '',
    },
  },
  computed: {
    shouldShowRanking: function () {
      return this.rankingList && this.rankingList.length > 0
    },
    displayTitle: function () {
      // グループ内個人ランキングの場合
      if (this.groupName) {
        return this.$t('agencyEventGroupRankingTitle', { name: this.groupName })
      }
      // 個人戦タブまたはグループ戦タブのグループランキング
      return this.$t('agencyEventRankingTitle')
    },
  },
  methods: {
    handleOpenGroupIndividualRanking(groupInfo) {
      this.$emit('openGroupIndividualRanking', groupInfo)
    },
  },
}
</script>

<style scoped>
.agency-event-ranking-list {
  max-width: 500px;
  margin: 0 auto;
}

.ranking-header {
  background-color: #fafafa;
  border-bottom: 1px solid #eeeeee;
}

.ranking-header__title {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  font-weight: bold;
  padding: 8px;
  text-align: left;
  color: #262626;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ranking-header__participants-counter {
  font-family: "Hiragino Kaku Gothic ProN";
  vertical-align: text-top;
  margin-left: 6px;
}

.ranking-header__participants-counter-icon {
  height: 16px;
  vertical-align: text-top;
}

.ranking-header__participants-counter-text {
  height: 16px;
  font-size: 13px;
  font-weight: normal;
  line-height: 16px;
  margin-left: 5px;
  color: #262626;
  vertical-align: text-top;
}

.ranking-header__participants-counter-container {
  height: 16px;
  line-height: 16px;
  vertical-align: text-top;
}

.ranking-content {
  background-color: #ffffff;
}

.empty-state__container {
  text-align: center;
  padding: 40px 20px;
}

.empty-state__img {
  margin: 40px auto 10px;
  height: 96px;
  width: 96px;
}

.empty-state__description p {
  font-size: 14px;
  color: #808080;
  margin: 0;
}
</style>
